import React from "react";

const Footer: React.FC = () => {
  const links = [
    { href: "/aboutUs", label: "About Us" },
    { href: "/legal", label: "Legal" },
    { href: "/contact", label: "Contact" },
  ];

  const socialIcons = [
    {
      href: "#",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M22.46 6c-.77.35-1.6.58-2.46.68a4.27 4.27 0 0 0 1.87-2.35 8.5 8.5 0 0 1-2.7 1.04 4.24 4.24 0 0 0-7.28 3.86A12.07 12.07 0 0 1 3.42 4.62a4.26 4.26 0 0 0 1.31 5.67A4.25 4.25 0 0 1 .64 9.9v.06a4.24 4.24 0 0 0 3.41 4.15 4.31 4.31 0 0 1-1.12.15 4.27 4.27 0 0 0 3.98 2.96A8.5 8.5 0 0 1 0 18.29a12.01 12.01 0 0 0 6.29 1.84c7.56 0 11.71-6.28 11.71-11.71 0-.18 0-.36-.01-.53a8.45 8.45 0 0 0 2.3-2.15z" />
        </svg>
      ),
    },
    {
      href: "#",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0z" />
        </svg>
      ),
    },
    {
      href: "#",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 2v4h-2V6c0-.55-.45-1-1-1s-1 .45-1 1v4H7V8c0-.55-.45-1-1-1s-1 .45-1 1v4H2v4h4v8h4v-8h3l1-4h-4V7c0-.45.22-.67.73-.73C14.54 6 15 5 15 4s-.46-2-2-2h-1z" />
        </svg>
      ),
    },
  ];

  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center">
        {/* Links */}
        <div className="flex space-x-6">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="text-gray-400 hover:text-white">
              {link.label}
            </a>
          ))}
        </div>

        {/* Social Media Icons */}
        <div className="flex space-x-6 mt-4 md:mt-0">
          {socialIcons.map(({ href, icon }, index) => (
            <a key={index} href={href} className="text-gray-400 hover:text-white">
              {icon}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
